import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import { SiteFooter } from "@/components/site-footer";
import { SiteHeader } from "@/components/site-header";
import About from "@/pages/about";
import Contact from "@/pages/contact";
import { Home } from "@/pages/home";
import { NotFound } from "@/pages/not-found";
import Services from "@/pages/services";
import CloudMigration from "@/pages/services/cloud-migration";
import DevOps from "@/pages/services/devops-automation";
import Infrastructure from "@/pages/services/infrastructure-networking";
import ITStrategy from "@/pages/services/it-strategy-roadmapping";

import { Providers } from "./providers";

function AppRoutes() {
  return (
    <Router>
      <Providers>
        <SiteHeader />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/services/it-strategy-roadmapping" element={<ITStrategy />} />
            <Route path="/services/cloud-migration" element={<CloudMigration />} />
            <Route path="/services/infrastructure-networking" element={<Infrastructure />} />
            <Route path="/services/devops-automation" element={<DevOps />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <SiteFooter />
      </Providers>
    </Router>
  );
}

export default AppRoutes;
